// extracted by mini-css-extract-plugin
export default {"root":"isc2_"};